import React from 'react';
import { DesktopOutlined, FontSizeOutlined, MobileOutlined, TabletOutlined } from '@ant-design/icons';
import css from './TextPresetsEditor.scss';

export default function TextPresetPlatformLabel({
	platform,
	label,
	referenceWidth,
}: {
	platform: string;
	label: string;
	referenceWidth?: number;
}) {
	const PlatformIcon =
		platform === 'base'
			? FontSizeOutlined
			: platform === 'tablet'
				? TabletOutlined
				: platform === 'mobile' || platform === 'mobileLandscape'
					? MobileOutlined
					: DesktopOutlined;
	return (
		<span className={css.platformLabel}>
			<PlatformIcon
				className={css.platformIcon}
				rotate={platform === 'mobileLandscape' ? 90 : undefined}
				aria-hidden
			/>
			<span className={css.platformDetails}>
				<span>{label}</span>
				{referenceWidth !== undefined ? <span className={css.platformWidth}>{referenceWidth}px</span> : null}
			</span>
		</span>
	);
}
